import { useQuery } from '@tanstack/react-query';

import { useHasPermission } from '../hooks';
import { CommandService } from '../services';

export const useCommandHistory = (commandId: string | null) => {
  const queryKey = ['commandHistory', commandId];
  const canViewHistory = useHasPermission('commands:read:history');

  const queryFn = () => CommandService.getCommandHistory(commandId!);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!commandId && canViewHistory,
    staleTime: 0,
  });
};
